/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListDocumentTagsQueryResponse,
  ListDocumentTagsQueryParams,
} from '../../types/ListDocumentTags'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listDocumentTags } from '../../clients/listDocumentTags'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listDocumentTagsQueryKey = (
  params?: ListDocumentTagsQueryParams
) => [{ url: '/api/v1/documents/tags/' }, ...(params ? [params] : [])] as const

export type ListDocumentTagsQueryKey = ReturnType<
  typeof listDocumentTagsQueryKey
>

export function listDocumentTagsQueryOptions(
  params?: ListDocumentTagsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listDocumentTagsQueryKey(params)
  return queryOptions<
    ListDocumentTagsQueryResponse,
    ResponseErrorConfig<Error>,
    ListDocumentTagsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listDocumentTags(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description List document tags.
 * Query Parameters:
 * - simple: If "true", returns simple non-paginated array for autocomplete
 * - search: Filter tags by name (case-insensitive contains)
 * Returns:
 * - Simple mode: [{"id": "...", "tag": "...", "color": "..."}]
 * - Paginated mode: {"count": N, "results": [...], ...}
 * @summary List document tags (paginated)
 * {@link /api/v1/documents/tags/}
 */
export function useListDocumentTags<
  TData = ListDocumentTagsQueryResponse,
  TQueryData = ListDocumentTagsQueryResponse,
  TQueryKey extends QueryKey = ListDocumentTagsQueryKey,
>(
  params?: ListDocumentTagsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListDocumentTagsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listDocumentTagsQueryKey(params)

  const query = useQuery(
    {
      ...listDocumentTagsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
